import { Drawer } from 'antd'

import { drawerAndModalWidth } from '../../../util/guideline'
import { CreateIsin } from './CreateIsin'

interface CreateIsinDrawerProps {
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const CreateIsinDrawer = ({ isVisible, onClose, onSuccess }: CreateIsinDrawerProps) => (
  <Drawer
    title="Create ISIN"
    placement="right"
    onClose={onClose}
    open={isVisible}
    width={drawerAndModalWidth}
    destroyOnClose
  >
    <CreateIsin onSuccess={onSuccess} />
  </Drawer>
)
